import{Indicator as t}from"@mantine/core";import{jsx as i}from"@emotion/react/jsx-runtime";function n({children:r,...o}){return i(t,{...o,children:r})}var a=n;export{a as Indicator};
